import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Input from '@mui/material/Input';
import NativeSelect from '@mui/material/NativeSelect';

const StyledNativeSelect = styled(NativeSelect)(({ theme }) => {
  return {
    marginTop: theme.spacing(1),
  };
});

const SelectInput = ({
  options,
  onChange,
  selectedValue,
  showEmptyOption = false,
  ...other
}) => {
  return (
    <StyledNativeSelect
      input={
        <Input
          name="name"
          id="frequency-control"
          value={selectedValue}
          onChange={onChange}
        />
      }
      {...other}
    >
      {showEmptyOption && <option value="" />}
      {options.map((opt, i) => {
        return (
          <option value={opt.value} key={i}>
            {opt.label}
          </option>
        );
      })}
    </StyledNativeSelect>
  );
};

SelectInput.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  showEmptyOption: PropTypes.bool,
};

export default SelectInput;
